import { useState } from 'react';
import { withCookies } from 'react-cookie';
import axios from 'axios';
import { pathOr } from 'rambda';
import { cookiesSetting, API_URL_COOKIE, localeAllowSwitcherCookie } from '../common/constants';
import withLocaleContext from '../components/hoc/withLocaleContext';
import { DEFAULT_LANGUAGE, SHOW_LANGUAGE_SWITCHER } from '../WebModule/i18n/params';
import { getLanguage, storeLanguage } from '../utils/i18n';

const ConfigProvider = ({ children, cookies, localeContext }) => {
  const { changeLocale } = localeContext;
  const [firstInit, setFirstInit] = useState(true);

  // from some reason useEffect was problematic for withLocaleContext,
  // that is why firstInit workaround is used
  if (firstInit) {
    axios
      .get('/appconfig.json')
      .then(response => {
        const apiUrl = pathOr(process.env.API_URL, 'data.api_url', response);
        const apiPort = pathOr(process.env.API_PORT, 'data.api_port', response);

        const urlValue = `${apiUrl}:${apiPort}`;
        cookies.set(API_URL_COOKIE, urlValue, cookiesSetting);

        // language variables
        const defaultLanguage = getLanguage(
          cookies,
          pathOr(DEFAULT_LANGUAGE, 'data.locale_default_language', response)
        );
        const languageSwitch = pathOr(
          SHOW_LANGUAGE_SWITCHER,
          'data.locale_allow_language_switcher',
          response
        );
        storeLanguage(cookies, defaultLanguage);
        changeLocale(defaultLanguage);
        cookies.set(localeAllowSwitcherCookie, languageSwitch, cookiesSetting);
      })
      .catch(error => {
        console.error('Error getting the config data (api url), applying env variables: ', error);
        const urlValue = `${process.env.API_URL}:${process.env.API_PORT}`;
        cookies.set(API_URL_COOKIE, urlValue, cookiesSetting);

        // language variables
        const oldDefaultLanguage = getLanguage(cookies, DEFAULT_LANGUAGE);
        const oldAllowSwitcher = cookies.get(localeAllowSwitcherCookie) || SHOW_LANGUAGE_SWITCHER;
        changeLocale(oldDefaultLanguage);
        cookies.set(localeAllowSwitcherCookie, oldAllowSwitcher, cookiesSetting);
      });

    setFirstInit(false);
  }

  return children;
};

export default withLocaleContext(withCookies(ConfigProvider));
